import { render, staticRenderFns } from "./ApplyDocument.vue?vue&type=template&id=f0d8abf8&"
import script from "./ApplyDocument.vue?vue&type=script&lang=js&"
export * from "./ApplyDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports